<template>
  <div class="bg-static-info-max rounded-lg flex items-center gap-8 p-16">
    <RevButtonBase
      class="hidden h-[168px] lg:block"
      :to="{
        type: 'external',
        href: APP_DOWNLOAD_BASE_URL,
      }"
      @click="trackQrCodeClick"
    >
      <!-- fontControlled="false" is necessary to avoid applying the 'nuxt-icon' class 
      Doc: https://github.com/cpsoinos/nuxt-svgo?tab=readme-ov-file#component-props
      -->
      <QRCode
        class="hidden md:block"
        :class="$style.qrCodeSvg"
        :filled="true"
        :font-controlled="false"
        height="168"
        viewBox="0 0 1130 1130"
        width="168"
      />
    </RevButtonBase>

    <div class="flex flex-col">
      <h2 class="heading-2">{{ i18n(translations.title) }}</h2>
      <p class="body-1">{{ i18n(translations.subtitle) }}</p>

      <AppStoreButtons
        class="mt-16 flex items-center"
        tracking-zone="reviews"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import AppStoreButtons from '@backmarket/nuxt-layer-base/components/AppStoreButtons/AppStoreButtons.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonBase } from '@ds/components/ButtonBase'

import translations from './AppIncentiveBlock.translations'
import QRCode from './QRCode.svg'

const APP_DOWNLOAD_BASE_URL = 'https://app.backmarket.com/j4lA/reviewcollection'

const i18n = useI18n()

const { trackClick } = useTracking()
const route = useRoute()

function trackQrCodeClick() {
  trackClick({
    zone: route.name?.toString?.() || '',
    name: 'download_app',
    value: 'qr_code',
  })
}
</script>

<style module>
/**
* This allows to fill the QR code with the bg-static-info-low
* All path elements of the SVG which have a fill prop are made transparent (instead of white)
*/
.qrCodeSvg path:nth-child(odd) {
  fill: transparent;
}
</style>
